import { render, staticRenderFns } from "./StallionPlanCuveDetail.vue?vue&type=template&id=4b2a7c22&"
import script from "./StallionPlanCuveDetail.vue?vue&type=script&lang=js&"
export * from "./StallionPlanCuveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports